import {
  ExternalBrowserPromptArrowIcon,
  ExternalBrowserPromptCloseIcon,
  ExternalBrowserPromptMoreIcon,
} from 'Icons'

type ExternalBrowserPromptProps = {
  title: string
  onClose: () => void
}

const ExternalBrowserPrompt = ({
  title,
  onClose,
}: ExternalBrowserPromptProps) => {
  return (
    <div className="absolute inset-0 z-[9999] bg-black/80">
      <div className="flex flex-col items-center text-left text-sm text-white md:hidden">
        <div>
          <div className="mt-10">For optimal experience:</div>
          <div className="mt-6 flex items-center">
            1. Tap the &ldquo;
            <div className="mx-[3px] rounded bg-[#AE5A48] px-1.5 py-1">
              <ExternalBrowserPromptMoreIcon />
            </div>
            &rdquo; on the upper right corner
          </div>
          <div className="mt-5">
            2. Choose &ldquo;
            <span className="mx-[3px] rounded bg-[#AE5A48] px-1.5 py-1">
              {title}
            </span>
            &rdquo;
          </div>
        </div>
        <div className="fixed right-[30px] top-0 rotate-[12deg]">
          <ExternalBrowserPromptArrowIcon />
        </div>
        <div
          className="fixed bottom-2 right-4 cursor-pointer"
          onClick={onClose}
        >
          <ExternalBrowserPromptCloseIcon />
        </div>
      </div>

      <div className="fixed right-[50px] top-0 text-left text-sm text-white max-md:hidden">
        <div>
          <div className="mt-10">For optimal experience:</div>
          <div className="mt-6 flex items-center">
            1. Tap the &ldquo;
            <div className="mx-[3px] rounded bg-[#AE5A48] px-1.5 py-1">
              <ExternalBrowserPromptMoreIcon />
            </div>
            &rdquo; on the upper right corner
          </div>
          <div className="mt-5">
            2. Choose &ldquo;
            <span className="mx-[3px] rounded bg-[#AE5A48] px-1.5 py-1">
              Open in external browser
            </span>
            &rdquo;
          </div>
        </div>
        <div className="fixed right-[30px] top-0 rotate-[12deg]">
          <ExternalBrowserPromptArrowIcon />
        </div>
        <div
          className="fixed bottom-2 right-4 cursor-pointer"
          onClick={onClose}
        >
          <ExternalBrowserPromptCloseIcon />
        </div>
      </div>
    </div>
  )
}

export default ExternalBrowserPrompt
